module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr20-eaf3f1469ce03730cc9e165872354109.jpg";